const DEFAULT_LANG = "heb";

const MESSAGE_TYPE_TO_UI = {
    "NoAvailableMessengers": {
        "heb": "אין שליחים זמינים"
    }
};

export const getMessageByType = (messageType, lang = DEFAULT_LANG) => {
    if (messageType in MESSAGE_TYPE_TO_UI && lang in MESSAGE_TYPE_TO_UI[messageType])
        return MESSAGE_TYPE_TO_UI[messageType][lang];

    return null;
};